import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetVideoParams } from "../interface";
import LandingVideo from "design-system/src/Components/WidgetPart/LandingVideo/LandingVideo";
import useBreakpoint from "design-system/src/Components/Grid/hooks/useBreakpoint";

const LandingStandardVideo: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetVideoParams>((props) => {
    const { p } = props;
    const { mobile } = useBreakpoint();

    return (
      <div style={{ padding: mobile ? "16px" : "24px", overflow: "hidden" }}>
        <LandingVideo
          videoId={p("video_src") || ""}
          poster={{
            desktop: p("poster_desktop") + "",
            mobile: p("poster_mobile") + "",
          }}
          title={p("title") || ""}
          highlightedTitle={p("subtitle") || ""}
          description={p("description") || ""}
        />
      </div>
    );
  });

export default LandingStandardVideo;
